import { api } from "./api";

const PART_SIZE = 5 * 1024 * 1024; // 5MB parts — safely under any ingress body limit

/**
 * Upload a (potentially large) Blob to the backend in small parts to bypass proxy body-size limits,
 * then assemble + persist it server-side. Used for full-session recordings and large video uploads.
 *
 * @param {Blob} blob               the assembled webm/mp4 blob
 * @param {object} opts
 * @param {"clip"|"session"} opts.kind
 * @param {object} [opts.params]    metadata forwarded to /uploads/complete (game, title, markers, …)
 * @param {string} [opts.ext]       file extension (default webm)
 * @param {(pct:number)=>void} [opts.onProgress]
 * @returns the created clip/session doc
 */
export async function uploadChunked(blob, { kind, params = {}, ext = "webm", onProgress } = {}) {
    const { data: init } = await api.post("/uploads/init", { kind });
    const uploadId = init.upload_id;
    const total = Math.max(1, Math.ceil(blob.size / PART_SIZE));
    for (let i = 0; i < total; i++) {
        const chunk = blob.slice(i * PART_SIZE, (i + 1) * PART_SIZE);
        const fd = new FormData();
        fd.append("upload_id", uploadId);
        fd.append("index", String(i));
        fd.append("file", chunk, `part-${i}`);
        await api.post("/uploads/part", fd, { headers: { "Content-Type": "multipart/form-data" } });
        onProgress?.(Math.round(((i + 1) / total) * 100));
    }
    const { data } = await api.post("/uploads/complete", { upload_id: uploadId, kind, ext, ...params });
    return data;
}
